import { css } from "styled-components";

// Margin Right
export const MarginRight8 = css`
    margin-right: 8px;
`;

export const MarginRight16 = css`
    margin-right: 16px;
`;

export const MarginRight20 = css`
    margin-right: 20px;
`;

export const MarginRight30 = css`
    margin-right: 30px;
`;

// Margin bottom
export const MarginBottom8 = css`
    margin-bottom: 8px;
`;

export const MarginBottom10 = css`
    margin-bottom: 10px;
`;

export const MarginBottom16 = css`
    margin-bottom: 16px;
`;

export const MarginBottom20 = css`
    margin-bottom: 20px;
`;

export const MarginBottom30 = css`
    margin-bottom: 30px;
`;

// Margin top
export const MarginTop8 = css`
    margin-top: 8px;
`;

export const MarginTop10 = css`
    margin-top: 10px;
`;

export const MarginTop16 = css`
    margin-top: 16px;
`;

export const MarginTop20 = css`
    margin-top: 20px;
`;

export const MarginTop30 = css`
    margin-top: 30px;
`;